import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SendMailRequest, SendMailResponse } from '@shared/index';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserMailService {

  constructor(private http: HttpClient) { }

  public async sendMail(request: SendMailRequest): Promise<SendMailResponse> {
    return await firstValueFrom(this.http.post<SendMailResponse>('/api/user/mail/send', request));
  }
}
